import { defineMessages } from 'react-intl';

export const ShareActions = Object.freeze({
  SHARE_TO_SOCIAL: 'SHARE_TO_SOCIAL',
  SHOW_SHARE_COACHMARK: 'SHOW_SHARE_COACHMARK',
  SHARE_OPTION_CLICKED: 'SHARE_OPTION_CLICKED',
} as const);

export const messages = defineMessages({
  cannotShareSong: {
    id: 'share.cannotShareSong',
    defaultMessage: 'Due to our music licenses, this song can’t be shared.',
  },
  cannotShareAlbum: {
    id: 'share.cannotShareAlbum',
    defaultMessage: 'Due to our music licenses, this album can’t be shared.',
  },
  cannotSharePlaylist: {
    id: 'share.cannotSharePlaylist',
    defaultMessage: 'Due to our music licenses, this playlist can’t be shared.',
  },
  cannotShareDefault: {
    id: 'share.cannotShareDefault',
    defaultMessage: 'Due to our music licenses, this can’t be shared.',
  },
  cannotSharePodcast: {
    id: 'share.cannotSharePodcast',
    defaultMessage: 'This podcast is currently unavailable.',
  },
} as const);
